import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-podcast.component.scss';
var ArticlePodcast = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePodcast, _super);
    function ArticlePodcast(element) {
        return _super.call(this, element) || this;
    }
    ArticlePodcast.prototype.init = function () {
    };
    ArticlePodcast.prototype.bindEvents = function () {
    };
    return ArticlePodcast;
}(Base));
export { ArticlePodcast };



//////////////////
// WEBPACK FOOTER
// ./components/article-podcast/article-podcast.component.ts
// module id = 112
// module chunks = 0